export default {
  data() {
    return {
      show: false
    }
  },
  mounted() {
    let self = this
    window.addEventListener('scroll', () => {
      let scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop)
      self.show = scrollTop > 0
    })
  },
  methods: {
    toTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  },
  template: `<a href="javascript:;" class="btn-gotop" v-if="show" @click="toTop"><i class="ico-gotop"></i></a>`
}


